import React from 'react';
import { Button } from '@jjj/components';
import { t } from '../../../../../../../../i18n';
import { SelectSubsection } from './selectionTooltip.style';

const SelectByStatusList = ({ statuses, onStatusSelect }) => (
  <SelectSubsection>
    <span className="actions-header">{t('dash.jobs.bookings.select_by_status_label')}</span>
    <ul className="list-no-style">
      {statuses.map(({ id, name }) => (
        <li key={id}>
          <Button
            type="link"
            onClick={event => onStatusSelect(event, { id, name })}
            data-cy="job-booking-pool-bulk-action-list-action-button"
          >
            {t(`dash.jobs.bookings.poolList.select_by_status.${name.replaceAll(' ', '_').toLowerCase()}`, {}, name)}
          </Button>
        </li>
      ))}
    </ul>
  </SelectSubsection>
);

export default SelectByStatusList;
